<template>
  <div>
    <div class="banner_wrap">
      <img
        src="../assets/images/banner.jpg"
        alt="银税通开放平台"
        class="bgMain"
      />
      <div class="loginMain">
        <div class="loginMain_in">
          <div class="loginMainFirst">
            <span class="second_font">开发者登录</span
            ><span class="loginTitleRight content_font"
              >没有账号？
              <a class="content_link" href="#/register">立即注册</a></span
            >
          </div>
          <div class="loginMainSecond">
            <div class="infoIndex_item">
              <input
                type="text"
                v-model="userName"
                placeholder="请输入您的账号"
              />
              <!--<p class="info_wro">请输入正确的账号</p>-->
            </div>
            <div class="infoIndex_item">
              <input
                type="password"
                v-model="passWord"
                placeholder="请输入您的密码"
              />
              <!--<p class="info_wro">请输入正确的账号</p>-->
            </div>
            <div class="infoIndex_item" v-show="isShow">
              <div id="slider" class="slider"></div>
            </div>
          </div>
          <a class="loginIndex_btn" @click="login">登录</a>
        </div>
      </div>
    </div>

    <!--成为我们的合作伙伴--->
    <div class="login_flo">
      <div class="login_floIn">
        <div class="flo_tit">
          <div class="flo_tit_h2">成为我们的合作伙伴</div>
          <p class="subtit remarks_font">
            赋能金融，互金机构，提供丰富、高度开放的API
          </p>
        </div>
        <div class="indexloginPic">
          <img src="../assets/images/login_pic.png" alt="成为合作伙伴" />
        </div>
        <div class="inforBottom">
          <ul class="login_partner_list clearfix">
            <li>
              <div class="third_font marginBott12">认证审核</div>
              <p>填写必要的注册信息，</p>
              <p>提前准备好您的企业邮箱等重要信息，</p>
              <p>开发者的联系信息</p>
            </li>
            <li>
              <div class="third_font marginBott12">等待审核</div>
              <p>填认证审核提交，</p>
              <p>等待审核结果，</p>
              <p>平台会发送账号等信息到您的企业邮箱</p>
            </li>
            <li>
              <div class="third_font marginBott12">平台使用</div>
              <p>登录平台获取相关参数，</p>
              <p>进行开发集成</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SliderVerification from "../assets/js/slider";
import JSEncrypt from "../assets/js/jsencrypt";

import qs from "querystring";
export default {
  name: "comHeader",
  data() {
    return {
      userName: "",
      passWord: "",
      num: 0,
      isShow: false,
      spinShow: true
    };
  },
  methods: {
    getIndexUrl() {
      if (process.env.NODE_ENV === "development") {
        return window.location.origin + "/";
      }
      return window.location.origin + "/dist/index.html";
    },
    normalizeRedirectUrl(url) {
      if (process.env.NODE_ENV !== "development" || !url) {
        return url;
      }
      return url.replace(
        window.location.origin + "/dist/index.html",
        window.location.origin + "/"
      );
    },
    login() {
      var testUrl = location.href;
      var tpl =
        qs.parse(testUrl.substring(testUrl.indexOf("?") + 1)).tpl || "finance";

      //	  		let params = {
      //	  			"username":this.userName,
      //				"password":this.passWord,
      //				"inputCaptcha":sessionStorage.getItem('token')
      //	  		}
      let params = {
        inputUsername: this.userName,
        inputPassword: this.passWord,
        inputCaptcha: sessionStorage.getItem("token"),
        tpl: tpl
      };
      if (this.check.calibration(params)) {
        if (sessionStorage.getItem("token") || !this.isShow) {
          var encrypt = new JSEncrypt();
          encrypt.setPublicKey(
            "MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAJw/nF+v0qHYsf5TxSVN97iHMydfBEsfCAVSSBSvxXtcWOOZN3fpeNoH9P5KPpxF9+BVrAynIV4dIFgRhE58aRECAwEAAQ=="
          );
          params.inputUsername = encrypt.encrypt(this.userName);
          params.inputPassword = encrypt.encrypt(this.passWord);
          this.http.post("/ystOpenPlatformBff/loginV3", params, res => {
            //							this.$Spin.hide();
            if (res.success) {
              sessionStorage.setItem("token", "");
              sessionStorage.setItem("certificate", res.data.token);
              //								sessionStorage.setItem('userName', res.data.userName)
              sessionStorage.setItem("devId", res.data.devId);
              sessionStorage.setItem("orgNo", res.data.orgNo || "");
              this.$store.dispatch("changeUserName", res.data.userName);
              //								alert(res.data.token)
              sessionStorage.setItem("passWord", this.passWord);
              if (res.data.state == 0) {
                var currentUrl = this.getIndexUrl();
                //									if(currentUrl.indexOf('http') == -1) {
                //										currentUrl = 'http://' + currentUrl
                //									}
                var u = currentUrl + "#/logChangePassword";
                window.location.href = u;
                //									window.location.href = BASE_URL + '/ystOpenPlatformBff/loadsession?u=' + u + '&devId=' + res.data.devId + "&token=" + res.data.token
              } else if (res.data.state == 1) {
                var currentUrl = this.getIndexUrl();
                //									if(currentUrl.indexOf('http') == -1) {
                //										currentUrl = 'http://' + currentUrl
                //									}
                //									sessionStorage.setItem('isLogin',true)
                //									var u = (qs.parse(testUrl.substring(testUrl.indexOf('?') + 1)).u || currentUrl + '/#/developCenter').replace('#', '$');
                var u = this.normalizeRedirectUrl(
                  qs.parse(testUrl.substring(testUrl.indexOf("?") + 1)).u ||
                    currentUrl + "#/developCenter"
                );
                window.location.href = u;
                //									window.location.href = BASE_URL + '/ystOpenPlatformBff/loadsession?u=' + u + '&devId=' + res.data.devId + "&token=" + res.data.token
              } else {
                this.$Message.error({
                  content: "此帐号已经锁定，请联系运维人员解除锁定才能登录！",
                  duration: 3
                });
              }
            } else {
              this.num++;
              if (this.num > 4 && !this.isShow) {
                this.$Message.error({
                  content: "密码错误超过5次，请通过滑块验证在登录！",
                  duration: 3
                });
                this.isShow = true;
              } else {
                this.$Message.error({
                  content: res.message,
                  duration: 3
                });
                if (this.num > 4) {
                  $("#slider").html("");
                  new SliderVerification("#slider", {
                    width: "330",
                    height: "50",
                    verifInfo: '/ystOpenPlatformBff/api/verifInfo',
                    checkVerif: '/ystOpenPlatformBff/api/checkVerif',
                  });
                }
              }
            }
          });
        } else {
          this.$Message.error({
            content: "请验证滑块验证码！",
            duration: 2
          });
        }
      }
    }
  },
  mounted() {
    //页面加载完成时调用
    sessionStorage.setItem("token", "");
    var sliderVerification = new SliderVerification("#slider", {
      width: "330",
      height: "50",
      verifInfo: '/ystOpenPlatformBff/api/verifInfo',
      checkVerif: '/ystOpenPlatformBff/api/checkVerif',
    });
  }
};
</script>

<style lang="scss">
.banner_wrap {
  position: relative;
  height: 520px;
  width: 100%;
  overflow: hidden;
  .bgMain {
    position: absolute;
  }
  @media only screen and (min-width: 800px) {
    .bgMain {
      left: 50%;
      margin-left: -1275px;
      display: block;
    }
  }

  .loginMain {
    width: 370px;
    min-height: 360px;
    background: $white;
    position: absolute;
    left: 50%;
    margin-left: 130px;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.3);
    top: 50px;
    color: $title;
    border-radius: 4px;
  }
  .loginMain_in {
    padding: 25px 20px;
    color: $title;
  }
  .loginTitle {
    font-size: 30px;
    font-weight: bold;
  }
  .loginTitleRight {
    float: right;
    font-size: 14px;
    margin-top: 3px;
  }

  .loginMainFirst {
    margin-bottom: 30px;
  }
  .info_item {
    margin-bottom: 30px;
  }
  .logo_icon {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 10px;
    top: 50%;
    margin-top: -10px;
  }
}

.login_btn {
  width: 330px;
  height: 50px;
  display: block;
  margin: 0 auto;
  text-align: center;
  line-height: 50px;
  border-radius: 4px;
  background: $link;
  color: $white;
  font-size: 18px;
  box-shadow: 0 6px 6px rgba(0, 128, 204, 0.13);
}

.login_flo {
  background: #fff;
  padding: 50px 0 35px;
  .login_floIn {
    width: 1000px;
    margin-right: auto;
    margin-left: auto;
  }
  .flo_tit {
    text-align: center;
    margin-bottom: 30px;
  }
  .flo_tit_h2 {
    font-size: 24px;
    color: $title;
  }
  .subtit {
    margin-top: 10px;
  }
  .login_partner_list h3 {
    font-size: 20px;
    color: $title;
  }
  .login_partner_list {
    margin-top: 40px;
  }
  .login_partner_list li {
    float: left;
    text-align: center;
    width: 33%;
  }
  .login_partner_list li p {
    font-size: 14px;
    color: $remarks;
    line-height: 24px;
  }
  .inforBottom {
    width: 100%;
    float: left;
    margin-bottom: 30px;
  }
  .indexloginPic {
    width: 100%;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/Login.vue